import React, { useState, useEffect } from 'react';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import { CallAPI } from '../../Services/service';
import endpoints from '../../Services/endpoint';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import {
  Box,
  Text,
  Image,
  Button,
  Divider,
  Input,
  Flex,
} from '@chakra-ui/react';
import ProfileImg from '../image/dummyBoyImage.png';
import Style from './Profile.module.css';
import { CiMail } from 'react-icons/ci';
import { MdOutlineLocalPhone } from 'react-icons/md';
const validateName = (name) => {
  const nameRegex = /^[a-zA-Z\s]+$/;
  return nameRegex.test(name) && name.trim().length > 0;
};

const validatePhoneNumber = (phoneNumber) => {
  const phoneRegex = /^\+?[0-9\s]{10,15}$/;
  return phoneRegex.test(phoneNumber);
};

export default function Profile() {
  const [originalProfile, setOriginalProfile] = useState({});
  const [error, setError] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [profile, setProfile] = useState({
    fullName: 'User Name',
    displayName: 'User Name',
    email: 'user123@email.com',
    mobileNumber: '',
    id: '', // Added id field
  });

  //   useEffect(() => {
  //     // Retrieve user profile from localStorage
  //     const savedProfile = localStorage.getItem('userProfile');

  //     if (savedProfile) {
  //       console.log(savedProfile);
  //       setProfile(JSON.parse(savedProfile)); // Parse the string into an object
  //       console.log('aftersaved', profile);
  //     } else {
  //       setProfile({
  //         fullName: 'John Marcom',
  //         displayName: 'John Marcom',
  //         email: 'marcomjohn1523@gmail.com',
  //         mobileNumber: '+91 9623412861',
  //         id: '26',
  //       });
  //     }
  //   }, []); // Empty dependency array to run only once on mount
  useEffect(() => {
    const initializeProfile = async () => {
      try {
        const savedProfile = JSON.parse(localStorage.getItem('userData'));
        const id = savedProfile?.id || profile.id;
        console.log('id is', id);
        if (!id) {
          toast.error('User ID not found');
          return;
        }
        const userProfile = await CallAPI(endpoints.findUser, { id });
        console.log('userProfile', userProfile);
        let user = userProfile.data;
        console.log(user);
        if (!validatePhoneNumber(user.mobile_number)) {
          setError('Please add your mobile number');
          user.mobile_number = '';
        }
        if (user && user.email_id && user.id) {
          setProfile({
            ...profile,
            email: user.email_id,
            id: id,
            fullName: `${user.first_name || ''} ${user.last_name || ''}`.trim(),
            displayName: `${user.first_name || ''} ${
              user.last_name || ''
            }`.trim(),
            mobileNumber: user.mobile_number || '',
          });
        } else {
          console.error('Failed to load user profile');
        }
      } catch (error) {
        console.error('Error fetching user profile:', error);
      }
    };

    initializeProfile();
  }, []);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };
  const handlePhoneNumberChange = (value) => {
    setProfile((prevProfile) => ({
      ...prevProfile,
      mobileNumber: value,
    }));
  };
  const handleEdit = () => {
    setOriginalProfile(profile); // Store the current profile data before editing
    setIsEditing(true);
  };

  const handleCancel = () => {
    setProfile(originalProfile); // Restore the original profile data
    setIsEditing(false);
  };
  const handleSave = () => {
    const existingData = JSON.parse(localStorage.getItem('userData')) || {};
    const splitData = profile.fullName.split(' ');
    const first_name = splitData[0];
    const last_name = splitData[1] || '';
    // Merge the existing data with the updated profile data
    const updatedData = {
      ...existingData, // Keep existing fields that are not in profile
      first_name: first_name,
      last_name: last_name,
      id: profile.id,
      mobile_number: profile.mobileNumber,
      email_id: profile.email,
    };

    // Save the merged data back to localStorage
    localStorage.setItem('userData', JSON.stringify(updatedData));
    const event = new Event('userDataChanged');
    window.dispatchEvent(event);
    setError('');
    setIsEditing(false);
  };

  const updateData = async (e) => {
    const { fullName, mobileNumber } = profile;
    if (!validateName(fullName)) {
      toast.error('Please enter a valid full name.');
      return;
    }

    if (!validatePhoneNumber(mobileNumber)) {
      toast.error('Please enter a valid phone number.');
      return;
    }
    e.preventDefault();
    console.log('profile is', profile);

    try {
      // CallAPI will send a POST request to the specified endpoint with the profile data
      const response = await CallAPI(endpoints.updateUser, profile);
      console.log('response is', response);
      // Assuming the response structure has status and message fields
      if (response?.code === 200) {
        toast.success(response?.message);
        handleSave(); // Save the updated profile to localStorage
        setIsEditing(false); // Exit the editing mode
      } else {
        toast.error(response?.message || 'Update failed!');
      }
    } catch (error) {
      console.error('Error updating user:', error);
      toast.error('Update failed!');
    }
  };

  return (
    <Flex direction="column" minHeight="100vh">
      <Flex flex="1">
        <Box flex="1" p="25px">
          <Text fontSize={'30px'} color={'#000000'} fontWeight={'500'}>
            Profile
          </Text>
          <Box
            width={'100%'}
            bg={'white'}
            height={'auto'}
            boxShadow={'1px 2px 10px lightgray'}
            borderRadius={'6px'}
            p={{ base: '10px', sm: '10px', md: '10px', lg: '40px' }}
          >
            <Box
              display={'flex'}
              flexDir={{ base: 'column', sm: 'column', md: 'row', lg: 'row' }}
              w={'100%'}
              justifyContent={'space-between'}
              alignItems={{ base: 'left', md: 'center' }}
            >
              <Box display={'flex'}>
                <Image
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALkAAACUCAMAAAD4QXiGAAAAPFBMVEX///+ZmZmVlZWSkpKqqqr4+Pj8/PydnZ2kpKT19fXi4uKPj4/v7+/p6ene3t7T09O8vLzKysqzs7PDw8Pb+pIdAAAGqklEQVR4nO1cW3frrA60BQZ8AWz8///rZ9J2J018GUB2us7JvHTth42nqpCENFBVH3zwwQcffPA/B6VU0zRtxPJz+de7CQFQ7dC5aQxSk/gCaRnGydmh/cP8287PwdSRLtV3UPwlah1m37XvpriG1o/R0I+Uf2P5bbQc/R8jr1zQRLRNO0J/sQ/uz7hNY2fqKRI7RmTf02xV3MZv5t26QAIh/QBBwb3baxofDnxkHUQhevz7zO5kTZCXrHCvpX8bb2tEjbn3BnkzvIX3MO+EQJC6mIfrPcab1H25BmEudZnFSu2YtTFfQTReavbO8PC+cTfdZbzVVOzhvyD8JUZXVRt6Tt4L+nBJbLdBFETCdYhwQXy0ktVTvkHSnm31jt3e39R1dy71jiOIr1MX7kTeVVef4So/3E+Mjp05j/eCxWFO8hd7LvFbBXYK9YExcW5TPwGNTNqd9IM6oRIWsmHnraoxgbgQOsxTxBi0SPiP/cjOvPK4q/R6dva7MaRa62aNlwvEW/WqlAwk+umpnaXaqRdgb+CWkTgxoDmf6vHVVVWlRvDAqkly7lJVzaCvktnKhA6NTGJmZA4nfSG3I/IAxyZOfwGdPBLfziU36sBKpLloq2rCYsORiy6bBTKBmLioW4j3Yk97tJABI8zRQiDUCO6tGIr36w4P2mDkKV/AUE7y+HMqYEbgCeqoyfvjP7GqLLJjdE0sRu8w4hSg1UCjs5wyAhaGBbKrVNWBYQqzwy4GMH+YBvoDN+DpRJTXAGBxK2bMMxVYR4ix+HiEVlroyd2hC5aeMSbQWeDkYdFKoiyRKiXBoxhcm6L1MpIe9oAeKEiis7YWrfQLs9GEemWAmYMRva6L3AX/DD9z3BhrwE+f/N5S5i4ebjgk7FB0SVHQBlB4j4U9KsZklB9d2oR+HHcmWmDyHd3i3Sk4caCprYbq5i14uDelSYIVV8Kwps939KRWImaghD9jrLpykdJ2Bj+TYozaZDNP6pf3yH5qk0aplEs88TPIMQY8YN2NkRcYoePuA44Do0tbsM/NonhoueGoxaXwjvAP89zgkhB6v6iH/XNMM4IKux9kny7Q3tb9S7v5OtYSaRNsyg2L6RP+frH6Fvl2TJdoyFzmyV+qRdhKSDYtrJQxzxncUhRmPZk9CkJ91jDVZEbFzJGzfDV77vT6YuZ1r6fhX/2lmsEnTBWfmechf8wvajl513Wd85Os88VT1zOPcpWbSu37x/XMTxIQXcD83chlnhbPdVTFL1nSGPkKY3SdoSrNjedwm+gLJHQYvRvW6vR2iLdHdCL57P5/Ut1CIhzdXWmtD33Smrl1C1wr6si7QxrejU3hvtSKeZnIoYGYalDjGXkM+P2GPlcIOIDMSeJfiNxh2UVvM23egMzn1F5UO4PMM9tzCpJYkM642aQ8Nv/PI15BRwvKHP9BKojccK6A4EImb4SmqubY2fv8qcWxlKhAdHXcCMhuWiyLHxE3uZs/wpojoU6+WQ5nOmXC64NWetGgaFcGpQu6xN/L73pj0Sx3t5vGoIfYd/WSv+juOIpBbWX1zh3eIsnlnp6IOBRuO/5SqCvalIwxqVD3QmPZLmq3T3Q8ouVtNV3BZO6GcWtheOi8j23TlCrRtyZSxKX7nTfcRRRr0DZsQkwyzsquM6fcxtwdG4MLzXYLZb0CWLJc4QeUWl05+4T4ivU8rYuXV+t6i4LB9jNW52glOot/WA25xHdjqVmxDEeyUMv5YqUYzZ8Ov2IlBtDEYpkVFRDjXYjVi0pct0Re8xyfKr9aFS5xXSp6VY1nt3DW8NqQKpQqPuClZXQuc7bAtRjgeZRZnpof8HxOZ707p8ypzH/FLjKsd0SfhItn2pz54pz6LXM9kTlTKL+j+RVfTvQW/rutzTU219uSh2z8LqSJD7+WPeXmPHoBqwSnvEOjFCpGzwf37vzHPUlsmA70fkwyb5Whj0oifsK98zsSh7spyB5+YoBvXGYQP/nRnGarP1KIs3z8EakqRow451FlE+6ER1xOfXXmjo7l+bM7SF72ItfAuk9pvPCtReXZ3hIj4flfPtkD1zM0wuw9bnAK1MTAna596u8HdiwMMlTPfO3JJCgXCtydxDvfn22cyRWA9sZduzNf4EyGz1B94aOK2+hGk6TmIzLjRTnzCMr6oEGPj6JGH/flu18o/kFrvez7I/ai76W3736d+AWqdaOO5GnN8YlEr0f3Fx9B/6LUuilIHSW69b0pobWRYfp6CfoPMn/AYDs/TfM3Ju/se94i/uCDDz74f8J/7DNODldonooAAAAASUVORK5CYII="
                  width={'70px'}
                  height={'60px'}
                  borderRadius={'50%'}
                />
                <Box
                  width={'auto'}
                  height={'auto'}
                  pl={{ base: '10px', md: '20px' }}
                >
                  <Text
                    className={Style?.textBottomMargin}
                    fontSize={'24px'}
                    color={'#000000'}
                    fontWeight={'600'}
                  >
                    {profile.fullName}
                  </Text>
                  <Text color={'#000000'} fontWeight={'400'} fontSize={'16px'}>
                    {profile.email}
                  </Text>
                </Box>
              </Box>
              {!isEditing ? (
                <Button
                  p={'20px 40px'}
                  bg={'red.500'}
                  color={'white'}
                  _hover={{ bg: 'red.400' }}
                  onClick={handleEdit}
                >
                  Edit
                </Button>
              ) : null}
            </Box>
            {isEditing ? (
              <Box>
                {/* Editing Mode */}
                <Box
                  display={'flex'}
                  mt={'40px'}
                  w={{ base: '100%', md: '50%' }}
                  flexDir={{ base: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                >
                  <Box>
                    <Text
                      className={Style?.textBottomMargin}
                      fontWeight={'500'}
                    >
                      Full Name
                    </Text>
                    <Input
                      value={profile.fullName}
                      name="fullName"
                      onChange={handleInputChange}
                      fontSize={'20px'}
                      color={'#000000'}
                      fontWeight={'500'}
                    />
                  </Box>
                  <Box>
                    <Text
                      className={Style?.textBottomMargin}
                      fontWeight={'500'}
                    >
                      Display Name
                    </Text>
                    <Text
                      name="displayName"
                      //   onChange={handleInputChange}
                      fontSize={'20px'}
                      color={'#000000'}
                      fontWeight={'500'}
                    >
                      {originalProfile.fullName}
                    </Text>
                  </Box>
                </Box>
                <Divider />
                <Box w={'100%'} pt={'40px'}>
                  <Text
                    className={Style?.textBottomMargin}
                    fontSize={'24px'}
                    color={'#000000'}
                    fontWeight={'600'}
                  >
                    My Email Address
                  </Text>
                  <Text className={Style?.textBottomMargin} fontWeight={'500'}>
                    You can use this email address to sign in to your account
                    and also to reset your password.
                  </Text>
                  <Box display={'flex'} mt={'30px'} alignItems={'center'}>
                    <Button bg={'red.400'}>
                      <CiMail size={'25'} color="white" />
                    </Button>
                    <Text
                      className={Style?.textBottomMargin}
                      color={'#000000'}
                      fontWeight={'400'}
                      fontSize={'16px'}
                      pl={'20px'}
                    >
                      {profile.email}
                    </Text>
                  </Box>
                </Box>
                <Box w={'100%'} pt={'40px'}>
                  <Text
                    className={Style?.textBottomMargin}
                    fontSize={'24px'}
                    color={'#000000'}
                    fontWeight={'600'}
                    mb={6}
                  >
                    My Mobile Number
                  </Text>
                  {/* <Input
                    value={profile.mobileNumber}
                    name="mobileNumber"
                    onChange={handleInputChange}
                    className={Style?.textBottomMargin}
                    fontWeight={'500'}
                  /> */}
                  <PhoneInput
                    country={'us'} // Set the default country
                    value={profile.mobileNumber}
                    onChange={handlePhoneNumberChange}
                    inputStyle={{
                      width: '40%',
                      borderRadius: '6px',
                      border: '1px solid lightgray',
                      paddingLeft: '50px', // Adjust padding for the flag
                      height: '36px',
                      marginTop: '6px',
                    }}
                    buttonStyle={{
                      border: 'none',
                      margin: '0px',
                      background: '#EDF2F7',
                      position: 'absolute',
                      left: '3px',
                      top: '2px',
                    }}
                    containerStyle={{
                      position: 'relative',
                      width: '100%',
                    }}
                  />
                  <Box display={'flex'} mt={'30px'} alignItems={'center'}>
                    <Button bg={'red.400'}>
                      <MdOutlineLocalPhone size={'25'} color="white" />
                    </Button>
                    <Text
                      className={Style?.textBottomMargin}
                      color={'#000000'}
                      fontWeight={'400'}
                      fontSize={'16px'}
                      pl={'20px'}
                    >
                      {profile.mobileNumber}
                    </Text>
                  </Box>
                </Box>
                <Flex gap={6}>
                  <Button
                    mt={'20px'}
                    bg={'green.400'}
                    color={'white'}
                    _hover={{ bg: 'green.500' }}
                    onClick={updateData}
                  >
                    Save
                  </Button>
                  <Button
                    mt={'20px'}
                    bg={'red.400'}
                    color={'white'}
                    _hover={{ bg: 'green.500' }}
                    onClick={handleCancel}
                  >
                    cancel
                  </Button>
                </Flex>
              </Box>
            ) : (
              <Box>
                {/* Viewing Mode */}
                <Box
                  display={'flex'}
                  mt={'40px'}
                  w={{ base: '100%', md: '50%' }}
                  flexDir={{ base: 'column', md: 'row' }}
                  justifyContent={'space-between'}
                >
                  <Box>
                    <Text
                      className={Style?.textBottomMargin}
                      fontWeight={'500'}
                    >
                      Full Name
                    </Text>
                    <Text
                      fontSize={'20px'}
                      color={'#000000'}
                      fontWeight={'500'}
                    >
                      {profile.fullName}
                    </Text>
                  </Box>
                  <Box>
                    <Text
                      className={Style?.textBottomMargin}
                      fontWeight={'500'}
                    >
                      Display Name
                    </Text>
                    <Text
                      fontSize={'20px'}
                      color={'#000000'}
                      fontWeight={'500'}
                    >
                      {profile.fullName}
                    </Text>
                  </Box>
                </Box>
                <Divider />
                <Box w={'100%'} pt={'40px'}>
                  <Text
                    className={Style?.textBottomMargin}
                    fontSize={'24px'}
                    color={'#000000'}
                    fontWeight={'600'}
                  >
                    My Email Address
                  </Text>
                  <Text className={Style?.textBottomMargin} fontWeight={'500'}>
                    You can use this email address to sign in to your account
                    and also to reset your password.
                  </Text>
                  <Box display={'flex'} mt={'30px'} alignItems={'center'}>
                    <Button bg={'red.500'} _hover={{ bg: 'red.400' }}>
                      <CiMail size={'25'} color="white" />
                    </Button>
                    <Text
                      className={Style?.textBottomMargin}
                      color={'#000000'}
                      fontWeight={'400'}
                      fontSize={'16px'}
                      pl={'20px'}
                    >
                      {profile.email}
                    </Text>
                  </Box>
                </Box>
                <Divider mt={'40px'} />
                <Box w={'100%'} pt={'40px'}>
                  <Text
                    className={Style?.textBottomMargin}
                    fontSize={'24px'}
                    color={'#000000'}
                    fontWeight={'600'}
                  >
                    My Mobile Number
                  </Text>
                  <Text className={Style?.textBottomMargin} fontWeight={'500'}>
                    You can use this mobile number to reset your password.
                  </Text>

                  <Box display={'flex'} mt={'30px'} alignItems={'center'}>
                    <Button bg={'red.500'} _hover={{ bg: 'red.400' }}>
                      <MdOutlineLocalPhone size={'25'} color="white" />
                    </Button>
                    {error ? (
                      <Text
                        className={Style?.textBottomMargin}
                        fontWeight={'500'}
                        pl={'20px'}
                      >
                        {error}
                      </Text>
                    ) : (
                      <Text
                        className={Style?.textBottomMargin}
                        color={'#000000'}
                        fontWeight={'400'}
                        fontSize={'16px'}
                        pl={'20px'}
                      >
                        {profile.mobileNumber}
                      </Text>
                    )}
                  </Box>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </Flex>
      <ToastContainer />
    </Flex>
  );
}
